import { EasiestQuiz } from "./EasiestQuiz";
// import { mediumQuiz } from "./mediumQuiz";
import { HardestQuiz } from "./HardestQuiz";

export const quizzes = {
  easiest: EasiestQuiz,
//   medium: mediumQuiz,
  hardest: HardestQuiz,
};